var Environment = {
  envURL: 'https://customcheckout.bambora.com.au',
  tokenizationURL: 'https://customcheckout.bambora.com.au/rapi/SecureTransactionToken',
  iframeURL: 'https://customcheckout.bambora.com.au/2.0.0/iframe.html',
  devEnvURL: 'https://devsandbox.ippayments.com.au',
  devTokenizationURL: 'https://devsandbox.ippayments.com.au/rapi/SecureTransactionToken',
  devIframeURL: 'https://devsandbox.ippayments.com.au/customcheckout/iframe.html',
};

module.exports = Environment;



//////////////////
// WEBPACK FOOTER
// ./env.js
// module id = 11
// module chunks = 0